export default {
    "title": "Inicio / {{client}}",
    "description": "Resumen de facturas y albaranes según periodo de referencia",
    "descriptionWithoutInvoices": "Resumen de albaranes según periodo de referencia",
    "descriptionWithoutDeliveryNotes": "Resumen de facturas según periodo de referencia",
    "lastYear": "Año anterior",
    "currentYear": "Año actual",
    "invoices": "Facturas",
    "deliveryNotes": "Albaranes",
    "invoicesChart": {
        "title": "Número de facturas e importe total mensual",
        "series": {
            "lastInvoices": "Nº facturas año anterior",
            "currentInvoices": "Nº facturas año actual",
            "lastTotal": "Importe año anterior",
            "currentTotal": "Importe año actual"
        }
    },
    "deliveryNotesChart": {
        "title": "Número de albaranes mensuales",
        "series": {
            "lastDeliveryNotes": "Año anterior",
            "currentDeliveryNotes": "Año actual"
        }
    },
    "noFeaturesMessage": "Bienvenido a la extranet de clientes"
}